import React from 'react';
import { AlertTriangle, RefreshCcw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="min-h-screen bg-[#111] flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-500">
                    <div className="w-20 h-20 bg-red-500/10 rounded-3xl flex items-center justify-center mb-6 border border-red-500/20 shadow-2xl">
                        <AlertTriangle size={40} className="text-red-500" />
                    </div>

                    <h1 className="text-3xl font-black text-white uppercase tracking-tighter mb-2">
                        Algo salió mal
                    </h1>

                    <p className="text-neutral-500 text-xs font-bold max-w-md mb-8 uppercase tracking-widest leading-relaxed">
                        Hemos detectado un problema inesperado. Nuestro equipo ha sido notificado automáticamente.
                    </p>

                    <div className="flex gap-4">
                        <button
                            onClick={this.handleReload}
                            className="bg-[#F59E0B] hover:bg-[#F59E0B]/90 text-black px-6 py-3 rounded-xl font-black text-xs uppercase tracking-wider flex items-center gap-2 transition-all active:scale-95"
                        >
                            <RefreshCcw size={16} strokeWidth={3} />
                            Reintentar
                        </button>

                        <button
                            onClick={this.handleGoHome}
                            className="bg-neutral-800 hover:bg-neutral-700 text-white px-6 py-3 rounded-xl font-black text-xs uppercase tracking-wider flex items-center gap-2 transition-all active:scale-95 border border-white/5"
                        >
                            <Home size={16} strokeWidth={3} />
                            Inicio
                        </button>
                    </div>

                    {/* Developer Details (Hidden in Prod usually, but good for debug now) */}
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <div className="mt-12 p-4 bg-black/50 rounded-xl border border-white/5 text-left max-w-lg w-full overflow-auto max-h-48">
                            <p className="text-red-400 font-mono text-xs mb-2">{this.state.error.toString()}</p>
                            <pre className="text-neutral-600 font-mono text-[10px] whitespace-pre-wrap">
                                {this.state.errorInfo?.componentStack}
                            </pre>
                        </div>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
